import Page from '@/components/page.vue'
import { Message } from 'element-ui'
import { dwgl } from '@/axios'
import Editxz from '../components/editxz.vue'
let that;
export default{
	data(){
		return{
			editXz:false,
			tableData:[],
			totalPage:0,
		}
	},
	components:{Page,Editxz},
	mounted() {
		that.typeList();
	},
	created() {
		that = this;
	},
	methods:{
		// 关闭新增或编辑弹窗
		closeXz(){
			this.editXz = false;
		},
		// 分页查询
		changedata(current){
			that.getdata.page = current;
			that.dataList();
		},
		// 详情
		godetail(data){
			that.$router.push({
				path:'/fbtz_detail',
				query:{
					id:data.tid
				}
			})
		},
		// 编辑
		editxzs(data){
			console.log(data);
		},
		// 评分项
		typeList(){
			dwgl.starDefault({
				user_id: that.$store.state.user.userinfo.id
			}).then(res => {
				if(res.code == 200){
					that.tableData = res.data;
				}else{
					Message.error(res.msg);
				}
			})
		},
		// 导出表格
		putOut(){
			dwgl.exportPartyOrgan({
				user_id:that.$store.state.user.userinfo.id,
				sign:12,
				status:''
			});
		},
		// 删除
		delPrine(item){

		}
	}
}